import TextField from '@mui/material/TextField'
import React from 'react'

const InputText = ({ value, defaultValue, onChange, error, ...rest }) => {
  const initial = value || defaultValue
  const [selectedVal, setSelectedVal] = React.useState(initial ? String(initial) : '')

  const handleChange = value => {
    setSelectedVal(value)
    if (onChange) {
      onChange(value)
    }
  }

  React.useEffect(() => {
    setSelectedVal(value)
  }, [value])

  return (
    <TextField
      fullWidth
      {...rest}
      error={Boolean(error)}
      helperText={error}
      value={selectedVal ?? ''}
      onChange={event => handleChange(event.target.value)}
      onKeyDown={event => {
        // Previne que ao pressionar ENTER no campo texto seja submitado o form
        if (event.key === 'Enter' && rest?.type === 'text') {
          event.preventDefault()
        }
      }}
      slotProps={{
        input: rest.InputProps,
        inputLabel: { shrink: true },
      }}
    />
  )
}

export default InputText
